import React, { useState, useEffect } from 'react';
import history from '../../../Communal/history';
import Reminder from '../../../Communal/reminder';
import Added from '../../../../images/added.png';
import AuditStatus from '../../../../images/audit-status.png';
import Denied from '../../../../images/denied.png';
import Pass from '../../../../images/pass.png';
import instance from '../../../Communal/instance';

const ElementDetail = ({ param }) => {
    const [detail, setDetail] = useState({});
    const [reminderShow, setReminderShow] = useState(false);
    const [calssDesc, setClassDesc] = useState({
        name: '',
        desc: ''
    })
    useEffect(() => {
        getDetail(param.match.params.id)
    }, [param])
    useEffect(() => {
        if (detail.classify) {
            getClassData();
        }
    }, [detail.classify])
    const getClassData = () => {
        instance.get('/scene_obj/classify/').then(res => {
            for (let i = 0; i < res.length; i++) {
                if (res[i].id === detail.classify) {
                    calssDesc.name = res[i].name;
                    calssDesc.desc = res[i].desc;
                }
            }
            setClassDesc({ ...calssDesc })
        })
    }
    const getDetail = (id) => {
        instance.get(`/scene_obj/${id}/`).then(res => {
            setDetail(res);
        })
    }
    return (
        <div className="activity-ctf-detail submit-ctf">
            <div className="banner"></div>
            <div className="content-container">
                <div className="submit-ctf-name submit-ctf-div">
                    <div style={{ display: "inline-block" }} className='ctf-name'>
                        <span onClick={() => history.push('/resource')}>资源中心</span> ＞ <span onClick={() => history.push({ pathname: '/resource/sceneelement', state: { tabKey: 1 } })}>场景对象资源</span> ＞ {detail.name}
                    </div>
                    {
                        detail.is_show_opin &&
                        <div className="status">
                            {
                                detail.status === 0 &&
                                <img src={AuditStatus} alt="" />
                            }
                            {
                                detail.status === 1 &&
                                <img src={Pass} alt="" />
                            }
                            {
                                detail.status === 2 &&
                                <img src={Added} alt="" />
                            }
                            {
                                detail.status === 3 &&
                                <img src={Denied} alt="" />
                            }
                        </div>
                    }
                </div>
                {
                    detail.is_show_opin && detail.opin && detail.opin.length > 0 &&
                    <div className="submit-ctf-div audit-opinion">
                        <div className="title" style={{ borderBottom: "1px solid #f4f4f4" }}>审核意见</div>
                        <div className="content">
                            <div>
                                {
                                    detail.opin &&
                                    detail.opin.map((val, key) => {
                                        return <div key={key + "key"}>
                                            <div className="time">[{val.time}]</div>
                                            <div className="details">
                                                <pre style={{ whiteSpace: "pre-line" }}>{val.msg}</pre>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                <div className="submit-ctf-div">
                    <div className="award">
                        <div>
                            <span>{detail.coin}</span>
                            <span>奖励</span>
                        </div>
                        <p onClick={() => setReminderShow(true)}>赚取更多奖励＞</p>
                    </div>
                    <div className="title">场景对象信息</div>
                    <div className="content">
                        {
                            detail.status === 1 &&
                            <div>
                                <span>场景对象编号</span>
                                <div>{detail.number ? detail.number : "暂无编号"}</div>
                            </div>
                        }
                        <div>
                            <span>对象名称</span>
                            <div>{detail.name}</div>
                        </div>
                        <div>
                            <span>对象分类</span>
                            <div>
                                名称：{detail.classify_name}<br />
                                描述：{calssDesc.desc}
                            </div>
                        </div>
                        <div>
                            <span>对象图片</span>
                            <div>
                                {
                                    detail.photo ?
                                        <img src={detail.photo} style={{ maxWidth: '50px' }} alt='' />
                                        : '暂无上传图片'
                                }
                            </div>
                        </div>
                        <div>
                            <span>对象描述</span>
                            <div style={{ paddingTop: "9px", lineHeight: "25px" }}>
                                <pre style={{ whiteSpace: "pre-wrap" }}>{detail.desc}</pre>
                            </div>
                        </div>
                        {
                            detail.status === 1 && [
                                <div key="2">
                                    <span>提交用户</span>
                                    <div>
                                        {detail.username}
                                    </div>
                                </div>,
                                <div key="3">
                                    <span>提交时间</span>
                                    <div>
                                        {detail.sub_time}
                                    </div>
                                </div>
                            ]
                        }
                    </div>
                </div>
            </div>
            {
                reminderShow &&
                <Reminder
                    close={() => setReminderShow(false)}
                />
            }
        </div>
    )
}
export default ElementDetail;